import { createContext, useContext } from 'react';

interface PendingImagesContextValue {
  pendingUrls: Set<string>;
  onLoaded: (url: string) => void;
}

const PendingImagesContext = createContext<PendingImagesContextValue | null>(null);

export const PendingImagesProvider = PendingImagesContext.Provider;
export const usePendingImages = () => useContext(PendingImagesContext);
